/* Petask "Kategoriler" pill menusu — canlidaki header pill'ini eslendirir */
(function () {
  function init() {
    var menu = document.querySelector('.header-menu');
    if (!menu || document.querySelector('.petask-cats-pill-wrap')) return;

    /* Canlı WP davranışı: tıklayınca panelde SADECE iki üst kategori (sağ ok ile),
       üstüne gelince alt kategoriler sağa doğru ikinci panelde açılır. */
    var wrap = document.createElement('div');
    wrap.className = 'petask-cats-pill-wrap';
    wrap.innerHTML =
      '<button type="button" class="petask-cats-pill" aria-expanded="false">' +
        '<span>Kategoriler</span><span class="petask-cats-pill__dots" aria-hidden="true">•••</span>' +
      '</button>' +
      '<div class="petask-cats-pill__panel" hidden>' +
        '<div class="petask-cats-item">' +
          '<a class="petask-cats-item__link" href="/collections/kedi-urunleri">Kedi Ürünleri<span class="petask-cats-item__arrow" aria-hidden="true">›</span></a>' +
          '<div class="petask-cats-item__fly">' +
            '<a href="/collections/kuru-kedi-mamasi">Kuru Kedi Maması</a>' +
            '<a href="/collections/yas-kedi-mamasi">Yaş Kedi Maması</a>' +
            '<a href="/collections/kedi-kumu">Kedi Kumu</a>' +
          '</div>' +
        '</div>' +
        '<div class="petask-cats-item">' +
          '<a class="petask-cats-item__link" href="/collections/kopek-urunleri">Köpek Ürünleri<span class="petask-cats-item__arrow" aria-hidden="true">›</span></a>' +
          '<div class="petask-cats-item__fly">' +
            '<a href="/collections/kuru-kopek-mamasi">Kuru Köpek Maması</a>' +
            '<a href="/collections/yas-kopek-mamasi">Yaş Köpek Maması</a>' +
          '</div>' +
        '</div>' +
      '</div>';

    menu.parentElement.insertBefore(wrap, menu);

    var btn = wrap.querySelector('.petask-cats-pill');
    var panel = wrap.querySelector('.petask-cats-pill__panel');

    function setOpen(willOpen) {
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
      btn.classList.toggle('is-open', willOpen);
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(panel.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* Not (2026-08-02): görünür arama çubuğu denendi ve kaldırıldı; header sağında
     arama ikonu + profil + sepet var. İkon Horizon'un kendi modalını açar, ama modal
     Enter'da sonuç sayfasına GİTMİYOR (öneri listesinde kalıyor). Kullanıcı isteği:
     marka/ürün adı yazıp Enter ya da arama butonuna basınca /search sonuç sayfası açılsın.
     Aşağısı bunu sağlar; modalın anlık öneri listesi olduğu gibi çalışmaya devam eder. */
  function goToSearch(value) {
    var q = (value || '').trim();
    if (!q) return;
    window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  function initSearchEnter() {
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter') return;
        var el = e.target;
        if (!el || el.tagName !== 'INPUT' || el.type !== 'search') return;
        if (!el.closest('#search-modal, dialog, .search-modal')) return;
        e.preventDefault();
        e.stopPropagation();
        goToSearch(el.value);
      },
      true // capture: Horizon kendi dinleyicisini çalıştırmadan yakala
    );
  }

  /* Modaldaki dekoratif büyüteci gerçek arama butonuna çevirir (tıkla → sonuç sayfası). */
  function initSearchButton() {
    document.addEventListener('click', function (e) {
      var icon = e.target.closest ? e.target.closest('.petask-search-go') : null;
      if (!icon) return;
      var box = icon.closest('#search-modal, dialog, .search-modal');
      var input = box ? box.querySelector('input[type="search"]') : null;
      if (input) {
        e.preventDefault();
        goToSearch(input.value);
      }
    });

    // Modal açıldığında büyüteç ikonunu tıklanabilir yap
    var mark = function () {
      document.querySelectorAll('#search-modal, dialog, .search-modal').forEach(function (box) {
        var input = box.querySelector('input[type="search"]');
        if (!input) return;
        var wrap = input.parentElement;
        if (!wrap || wrap.querySelector('.petask-search-go')) return;
        var svg = wrap.querySelector('svg');
        if (svg) {
          svg.classList.add('petask-search-go');
          svg.style.cursor = 'pointer';
          svg.setAttribute('role', 'button');
          svg.setAttribute('aria-label', 'Ara');
        }
      });
    };
    document.addEventListener('click', function () { setTimeout(mark, 300); });
    setTimeout(mark, 1200);
  }

  /* Arama kutusu BOŞKEN öneri paneli gizlenir (kullanıcı kararı 2026-08-03).
     Horizon boş sorguda "öne çıkan ürünler" + "son görüntülenen" basıyor; istenmedi.
     Liquid'de load_empty_state:false DENENDİ → modal hiç açılmadı, geri alındı.
     Bu yüzden ayrım JS ile yapılır: input boşsa panele .petask-search-empty eklenir,
     CSS onu gizler. Yazmaya başlayınca sınıf kalkar, öneriler görünür. */
  function initSearchEmptyState() {
    /* Yazmaya başlandığı an panelde HÂLÂ eski içerik duruyor (Horizon sonucu AJAX ile
       sonra basıyor). O yüzden sadece "input boş mu" yetmez: yeni sonuç gelene kadar
       da gizli tutarız, yoksa bir an önceki/varsayılan ürünler görünüp değişiyor. */
    var sonucBekleniyor = false;
    var beklemeZamanlayici = null;

    function uygula() {
      document.querySelectorAll('#predictive-search-results').forEach(function (panel) {
        var kutu = panel.closest('#search-modal, dialog, .search-modal, .predictive-search') || document;
        var input = kutu.querySelector('input[type="search"]');
        var bos = !input || !input.value.trim();
        var gizle = bos || sonucBekleniyor;
        var varMi = panel.classList.contains('petask-search-empty');
        // Yalnızca gerçekten değişecekse dokun — aksi hâlde gözlemci sonsuz döngüye girer
        if (gizle && !varMi) panel.classList.add('petask-search-empty');
        else if (!gizle && varMi) panel.classList.remove('petask-search-empty');
      });
    }

    document.addEventListener('input', function (e) {
      if (!e.target || e.target.type !== 'search') return;
      sonucBekleniyor = !!e.target.value.trim();
      uygula();
      // Güvenlik ağı: yanıt hiç gelmezse panel sonsuza dek gizli kalmasın
      clearTimeout(beklemeZamanlayici);
      if (sonucBekleniyor) {
        beklemeZamanlayici = setTimeout(function () {
          sonucBekleniyor = false;
          uygula();
        }, 2500);
      }
    });
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.type === 'search') uygula();
    });
    document.addEventListener('click', function () {
      setTimeout(uygula, 60);
      setTimeout(uygula, 300);
    });

    /* Horizon öneri panelini AJAX ile yeniden basıyor. Panelin İÇERİĞİ değiştiğinde
       yeni sonuç gelmiş demektir → beklemeyi bitir ve göster. Ayrıca yeniden basımda
       silinen sınıfımızı geri koyar. */
    if (window.MutationObserver) {
      new MutationObserver(function (kayitlar) {
        var icerikDegisti = kayitlar.some(function (k) {
          if (k.type !== 'childList' || !k.target || !k.target.closest) return false;
          return !!k.target.closest('#predictive-search-results');
        });
        if (icerikDegisti && sonucBekleniyor) {
          sonucBekleniyor = false;
          clearTimeout(beklemeZamanlayici);
        }
        uygula();
      }).observe(document.body, { childList: true, subtree: true });
    }
    setTimeout(uygula, 400);
  }

  function boot() {
    init();
    initSearchEnter();
    initSearchButton();
    initSearchEmptyState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
